module.exports = __webpack_public_path__ + "img/16581306_L.0f4dcb14.png";